import { DefaultPopover, Separator } from 'twyne-new.ui';

import { InfoIcon } from '@Components/pure/form-builder/FieldForm';

import { useCodeEditor } from './CodeEditor/context';

export default function ContinueNoConsent({ id, targetPaste }) {
  const { editorsRef } = useCodeEditor()

  const linkContent = '<a notcpaconsent>Clickable Text</a>'

  const handlePasteLinkContent = () => {
    const editor = editorsRef.current[targetPaste]
    editor.setValue(editor.getValue() + linkContent)
  }

  return <span>
    <DefaultPopover
      trigger={<InfoIcon id={id} />}
      contentProps={{ side: 'right' }}
    >
      How to use
      <Separator className='m-0 my-2' />
      Use <span className='twy-text-accent hover:underline'><em>
        <a
          href='javascript:void(0)'
          onClick={handlePasteLinkContent}
        >
          {linkContent}
        </a>
      </em></span> to allow the consumer continue to the next step without providing tcpa consent.

    </DefaultPopover>
  </span>
}
